import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=81fbb27e&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fbb27e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81fbb27e')) {
      api.createRecord('81fbb27e', component.options)
    } else {
      api.reload('81fbb27e', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=81fbb27e&scoped=true&", function () {
      api.rerender('81fbb27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sidebar.vue"
export default component.exports